module.exports = __webpack_public_path__ + "img/tupian.eba5dbc3.png";